import {
  AnonymousCredential,
  BlockBlobClient,
  BlockBlobParallelUploadOptions,
} from "@azure/storage-blob";

import {
  ShareFileClient,
  FileParallelUploadOptions
} from "@azure/storage-file-share";

export class FileService {
  public uploadFile(file: File, sasUri: string, progressCallback: Function) {
    return new Promise<void>((resolve, reject) => {
      const cred = new AnonymousCredential();
      const client = new BlockBlobClient(sasUri, cred);
      const options: BlockBlobParallelUploadOptions = {
        onProgress: (p) => progressCallback(p),
        maxSingleShotSize: 4 * 1024 * 1024,
        blockSize: 4 * 1024 * 1024,
        concurrency: 4,
      };
      return client
        .uploadData(file, options)
        .then(() => resolve())
        .catch((e) => reject(e));
    });
  }

  public uploadFileToFileService(file: File, sasUri: string, progressCallback: Function) {
    return new Promise<void>((resolve, reject) => {
      const client = new ShareFileClient(sasUri);
      const options: FileParallelUploadOptions = {
        onProgress: (p) => progressCallback(p),
        rangeSize: 4 * 1024 * 1024
      };
      return client
        .uploadData(file, options)
        .then(() => resolve())
        .catch(e => reject(e));
    });
  }
}
